import styled from 'styled-components';
import { colorSet } from '@components/Provider';

export const Main = styled.main`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-bottom: 0px;
  min-height: 100vh;
  background-color: ${colorSet.backgroundLight};
  color: ${colorSet.gray900};
  text-align: center;
  .title {
    font-weight: bold;
    font-size: 32px;
    line-height: 48px;
    margin-bottom: 4px;
  }
  .description {
    font-size: 14px;
    line-height: 20px;
  }
  img {
    display: block;
    width: 100%;
    max-width: 720px;
    margin: 20px auto;
    margin-bottom: 60px;
  }
`;
